import { useState } from "react";
import { LANGS } from "../../i18n/marketing";
import { Globe, Check } from "lucide-react";

// Kompakt språkbytter — gull-accent, brand-lik. Popover åpner en liten
// meny med tre valg (Norsk, English, Deutsch). Persistens håndteres av
// hooken.
export default function LanguageSwitcher({ lang, setLang, dark = false }) {
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <div className="relative" onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        data-testid="marketing-lang-toggle"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs uppercase tracking-widest transition ${
          dark
            ? "border-white/20 text-white/85 hover:bg-white/10"
            : "border-[#A57F39]/40 text-[#0F1A2B]/85 hover:bg-[#A57F39]/10"
        }`}
      >
        <Globe className="h-3.5 w-3.5" />
        <span>{current.flag}</span>
        <span>{current.code.toUpperCase()}</span>
      </button>
      {open && (
        <div
          data-testid="marketing-lang-menu"
          className="absolute right-0 mt-2 z-50 min-w-[160px] rounded-lg border border-[#A57F39]/30 bg-white shadow-2xl overflow-hidden"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`marketing-lang-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between gap-2 px-3 py-2 text-sm hover:bg-[#A57F39]/10 transition ${
                lang === l.code ? "bg-[#A57F39]/5 text-[#A57F39] font-semibold" : "text-[#0F1A2B]"
              }`}
            >
              <span className="flex items-center gap-2">
                <span>{l.flag}</span>
                <span>{l.label}</span>
              </span>
              {lang === l.code && <Check className="h-4 w-4" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
